import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationSendService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  private buildEntryData(section: any, dataPoints: any[]) {
    return section.dataPointValues.map((dpv: any, i: number) => ({
      dataPointName: dataPoints[i]?.dataPointName ?? '',
      value: dpv.value ?? '',
      note: dpv.note ?? '',
    }));
  }

  private extractReferences(section: any): string[] {
    const refs = new Set<string>();
    for (const dpv of section.dataPointValues) {
      const val: string = (dpv.value ?? '').toString();
      if (!val.trim()) continue;
      val.split(',').map((v: string) => v.trim()).filter((v: string) => v).forEach((v: string) => refs.add(v));
    }
    return Array.from(refs);
  }

  sendInProgress(logSheetId: number, entryNumber: number, section: any, dataPoints: any[]): void {
    const entryData = this.buildEntryData(section, dataPoints);
    const recipientReferences = this.extractReferences(section);
    this.http.post(`${this.baseUrl}/Sms/send-in-progress/${logSheetId}`, {
      entryNumber,
      entryData,
      recipientReferences,
    }).subscribe({ error: () => {} });
  }

  sendSubmission(logSheetId: number, entryNumber: number, section: any, dataPoints: any[]): void {
    const entryData = this.buildEntryData(section, dataPoints);
    this.http.post(`${this.baseUrl}/Sms/send-submission/${logSheetId}`, {
      entryNumber,
      entryData,
    }).subscribe({ error: () => {} });
  }
}
